import React from "react";
import api from "../../../api";
import styled from "styled-components";
import {notification, Typography} from "antd";
import {getPaymentTypes, getPoints} from "../../../utils";


const {Title, Text} = Typography;

const INITIAL_MANUAL_ORDERS_FILTER = "&filters[0][t]=more&filters[0][f]=admin_id&filters[0][v]=0"

export function useGetData() {
    const [ items, setItems ] = React.useState([])
    const [ pagination, setPagination ] = React.useState(null)
    const [ appliedFilters, setAppliedFilters ] = React.useState(INITIAL_MANUAL_ORDERS_FILTER)
    const [ searchOrders, setSearchOrders ] = React.useState([])
    const [ searchOrdersFull, setSearchOrdersFull ] = React.useState([])
    const [ searchUsersAddresses, setSearchUsersAddresses ] = React.useState([])
    const [ searchUsersAddressesFull, setSearchUsersAddressesFull ] = React.useState([])
    const [ searchUser, setSearchUser ] = React.useState(null)
    const [ pointOptions, setPointOptions ] = React.useState([])
    const [ deliveryTypes, setDeliveryTypes ] = React.useState([])
    const [ paymentTypes, setPaymentTypes ] = React.useState([])
    const [ intervals, setIntervals ] = React.useState(null)
    const [ isLoading, setIsLoading ] = React.useState(false)
    const [ isLoadingSearchData, setIsLoadingSearchData ] = React.useState(false)

    React.useEffect(() => {
        getItems(1, 20, INITIAL_MANUAL_ORDERS_FILTER)
        getPointOptions()
        getDeliveryTypes()
        getDataPaymentTypes()
    }, [])

    async function getItems(page = 1, countOnPage = 20, filters = "") {
        setIsLoading(true)
        try {
            const response = await api.get(
                `orders?page=${page}&countOnPage=${countOnPage}${filters}`
            )
            setPagination({
                current: response.data.pagination.currentPage,
                pageSize: response.data.pagination.countOnPage,
                total: response.data.pagination.total,
            })
            setItems(response.data.items)

            setIsLoading(false)
        } catch (error) {
            setIsLoading(false)
        }
    }

    async function getPointOptions() {
        const data = await getPoints()

        const options = data.map((item) => ({
            label: item.shortName,
            value: item.id,
        }))
        setPointOptions(options)
    }

    async function getDataPaymentTypes() {
        const types = await getPaymentTypes()
        const newItems = types.map((item) => {
            return {
                label: item.name.find((el) => el.language === "ru").content,
                value: item.id,
                slug: item.slug
            }
        })
        setPaymentTypes(newItems)
    }

    async function getDeliveryTypes() {
        try {
            const { data } = await api.get("delivery-types")
            const options = data.items.filter((item) => item.slug !== "table").map((item) => ({
                value: item.id,
                label: item?.name?.find((el) => el.language === "ru").content ?? item.slug,
                slug: item.slug
            }))
            setDeliveryTypes(options)
        } catch (error) {
            console.error(error)
        }
    }

    async function onSearchUserAddresses(userId) {
        setIsLoadingSearchData(true)
        try {
            const addressRes = await api.get(`users/address/${userId}`)
            const formattedAddresses = formattedSearchAddresses(addressRes.data.addresses)
            setSearchUsersAddresses(formattedAddresses)
            setSearchUsersAddressesFull(addressRes.data.addresses)

            const { data } = await api.get(`users/${userId}`)
            setSearchUser(data.user)
        } catch (error) {
            console.log("Ошибка получения aдресов пользователя", error);
        } finally {
            setIsLoadingSearchData(false)
        }
    }

    async function onSearchOrders(filters) {
        setIsLoadingSearchData(true)
        try {
            const { data } = await api.get(
                `orders?page=${1}&countOnPage=${20}${filters}`
            )

            const formattedOrders = formattedSearchOrder(data.items, pointOptions)
            setSearchOrdersFull(data.items)
            setSearchOrders(formattedOrders)
        } catch (error) {
            console.log("Ошибка получения заказов", error);
        } finally {
            setIsLoadingSearchData(false)
        }
    }

    // Тип получения передаём явно: без него бэкенд берёт тип из корзины самого администратора,
    // а самовывоз и доставка считаются по разным графикам.
    async function getIntervals(pointId, deliveryTypeSlug) {
        setIsLoadingSearchData(true)
        try {
            const deliveryTypeParam = deliveryTypeSlug ? `&deliveryType=${deliveryTypeSlug}` : ""
            const { data } = await api.get(`preorder/intervals?cityId=1&pointId=${pointId}${deliveryTypeParam}`, {prefix: "user"})
            setIntervals(data.daysWithIntervals ?? null)
        } catch (error) {
            console.log("Ошибка получения интервалов", error);
        } finally {
            setIsLoadingSearchData(false)
        }

    }

    function handleSearchTable(filters, paginationSet = null) {
        let filters_str = INITIAL_MANUAL_ORDERS_FILTER
        let count = 1

        for (let [key, value] of Object.entries(filters)) {
            if (value) {
                switch (key) {
                    case "phone":
                        filters_str += `&filters[${count}][t]=iL&filters[${count}][f]=user.phone&filters[${count}][v]=${value}`
                        count++
                        filters_str += `&filters[${count}][o]=orW&filters[${count}][t]=iL&filters[${count}][f]=guest_user_phone&filters[${count}][v]=${value}`
                        break
                    case "email":
                        filters_str += `&filters[${count}][t]=iL&filters[${count}][f]=user.email&filters[${count}][v]=${value}`
                        count++
                        filters_str += `&filters[${count}][o]=orW&filters[${count}][t]=iL&filters[${count}][f]=guest_user_email&filters[${count}][v]=${value}`
                        break
                    case "innerId":
                        filters_str += `&filters[${count}][t]=iL&filters[${count}][f]=inner_id&filters[${count}][v]=${value}`
                        break
                    case "totalPriceWithDiscount":
                        filters_str += `&filters[${count}][t]=equal&filters[${count}][f]=total_price_with_discount&filters[${count}][v]=${value}`
                        break
                    case "dateFrom":
                        filters_str += `&filters[${count}][t]=more&filters[${count}][f]=created_at&filters[${count}][v]=${value}`
                        break
                    case "dateTo":
                        filters_str += `&filters[${count}][t]=less&filters[${count}][f]=created_at&filters[${count}][v]=${value}`
                        break
                }
                count++
            }
        }

        setAppliedFilters(filters_str)

        if (paginationSet) {
            getItems(paginationSet.current, paginationSet.pageSize, filters_str)
        } else {
            getItems(1, 20, filters_str)
        }
    }

    function handleSearchOrders(filters) {
        let filters_str = ""
        let count = 0

        for (let [key, value] of Object.entries(filters)) {
            if (value) {
                switch (key) {
                    case "phone":
                        filters_str += `&filters[${count}][t]=iL&filters[${count}][f]=user.phone&filters[${count}][v]=${value}`
                        count++
                        filters_str += `&filters[${count}][o]=orW&filters[${count}][t]=iL&filters[${count}][f]=guest_user_phone&filters[${count}][v]=${value}`
                        break
                    case "email":
                        filters_str += `&filters[${count}][t]=iL&filters[${count}][f]=user.email&filters[${count}][v]=${value}`
                        count++
                        filters_str += `&filters[${count}][o]=orW&filters[${count}][t]=iL&filters[${count}][f]=guest_user_email&filters[${count}][v]=${value}`
                        break
                    case "innerId":
                        filters_str += `&filters[${count}][t]=iL&filters[${count}][f]=inner_id&filters[${count}][v]=${value}`
                        break
                    case "totalPriceWithDiscount":
                        filters_str += `&filters[${count}][t]=equal&filters[${count}][f]=total_price_with_discount&filters[${count}][v]=${value}`
                        break
                    case "dateFrom":
                        filters_str += `&filters[${count}][t]=more&filters[${count}][f]=created_at&filters[${count}][v]=${value}`
                        break
                    case "dateTo":
                        filters_str += `&filters[${count}][t]=less&filters[${count}][f]=created_at&filters[${count}][v]=${value}`
                        break
                }
                count++
            }
        }

        if (count > 0) {
            onSearchOrders(filters_str)
        }
    }

    async function createOrder(order) {
        try {
            const {data} = await api.post('orders/from-dashboard', order)

            notification.success({message: `Заказ ${data.innerId} оформлен`})
            await getItems(pagination?.current ?? 1, pagination?.pageSize ?? 20, appliedFilters)
        } catch (error) {
            notification.error({ message: "Ошибка оформления заказа" })
        }
    }

    function handleTableChange(paginationData) {
        getItems(paginationData.current, paginationData.pageSize, appliedFilters)
    }

    async function handlePaymentCheck(id) {
        setIsLoading(true)
        try {
            const response = await api.get(`orders/payment/${id}`)

            getItems(pagination?.current ?? 1, pagination?.pageSize ?? 20, appliedFilters)

            setIsLoading(false)
        } catch (e) {
            setIsLoading(false)
        }
    }

    async function resendToCrm(id) {
        setIsLoading(true)
        try {
            const response = await api.get(`orders/send/${id}`)

            getItems(pagination?.current ?? 1, pagination?.pageSize ?? 20, appliedFilters)

            setIsLoading(false)
        } catch (e) {
            setIsLoading(false)
        }
    }

    function handleClearSearch() {
        setSearchOrders([])
        setSearchOrdersFull([])
        setSearchUser(null)
        setSearchUsersAddresses([])
        setSearchUsersAddressesFull([])
    }

    function handleClearFilter() {
        setAppliedFilters(INITIAL_MANUAL_ORDERS_FILTER)
        getItems(pagination.current, pagination.pageSize)
    }

    return {
        items,
        pagination,
        isLoading,
        refetch: () => getItems(pagination?.current || 1, pagination?.pageSize || 20, appliedFilters),
        isLoadingSearchData,
        handleSearchOrders,
        handleClearSearch,
        onSearchUserAddresses,
        searchOrders,
        searchOrdersFull,
        searchUsersAddresses,
        searchUsersAddressesFull,
        searchUser,
        getIntervals,
        intervals,
        createOrder,
        handleTableChange,
        handleSearchTable,
        handleClearFilter,
        handlePaymentCheck,
        resendToCrm,
        options: {
            pointOptions,
            deliveryTypes,
            paymentTypes
        }
    }
}

function formattedSearchOrder(orders, points) {
    return orders.map((order) => {
        const user = (order.dashboardUser.phone && order.dashboardUser.phone !== "")
            ? order.dashboardUser.phone
            : ((order.dashboardUser.email && order.dashboardUser.email !== "") ? order.dashboardUser.email : `UserId: ${order.dashboardUser.id}`)

        const address = order.dashboardOrder.deliveryTypeSlug === "delivery"
            ? order.dashboardOrder.dashboardUserAddresses?.dashboardAddress?.textAddress?.replace("Россия, г Санкт-Петербург, ", "") ?? "адрес отсутствует"
            : points.find((point) => point.value === order.dashboardOrder.pointId)?.label ?? "Точка не найдена"

        return {
            value: order.dashboardOrder.id,
            label: (
                <OptionItem>
                    <Text strong>{`Заказ№: ${order.dashboardOrder.innerId}`}</Text>
                    <Text><strong>Пользователь:</strong> {user}; <strong>Cумма:</strong> {order.dashboardOrder.totalPriceWithDiscount}₽</Text>
                    <Text><strong>Тип:</strong> {order.dashboardOrder.deliveryType}; <strong>Адресс/Toчка:</strong> {address}</Text>
                </OptionItem>
            ),
        }
    })
}

function formattedSearchAddresses(addresses) {
    return addresses.map((address) => {
        const addressName = address.name?.length > 0
            ? address.name
            : address.addressForView

        return {
            value: address.id,
            label: (
                <OptionItem>
                    <Text strong>{`Название: ${addressName}`}</Text>
                    <Text><strong>Адрес:</strong> {address.addressForView};</Text>
                    {!address.isPrivateHouse
                        ? <Text><strong>Квартира:</strong> {address.apartment ?? "Не заполнено"}; <strong>Этаж:</strong> {address.floor ?? "Не заполнено"}; <strong>подъезд:</strong> {address.entrance ?? "Не заполнено"}</Text>
                        : <Text strong>Частный дом</Text>
                    }
                </OptionItem>
            ),
        }
    })

}

const OptionItem = styled.div`
  display: flex;
  flex-direction: column;
  padding: 4px 0;
`